import React, {useEffect} from 'react'
import {observer} from 'mobx-react'
import PropTypes from 'prop-types';
import {useStores} from "../../../Hooks";
import {procedureNodeTypeEnum} from "../../../serverClientShared/sharedEnums";
import {getProcedureText} from "../../../serverClientShared/sharedUtils";

const SelectionMenu = observer(props => {
    const {procedureStore, generalStore} = useStores();

    const {sessionViewerOpen} = procedureStore;

    const currentNode = (props.isPreview ? procedureStore.currentPreviewedNode : procedureStore.currentNode) || {};
    const currentProcedure = (props.isPreview ? procedureStore.currentPreviewedProcedure : procedureStore.currentProcedure) || {}

    const isSelectionStep = !!currentNode && [procedureNodeTypeEnum.MULTI, procedureNodeTypeEnum.QUESTION].includes(currentNode.NodeType);

    useEffect(() => {
        if (!isSelectionStep || sessionViewerOpen || currentNode.userSelection) {
            return;
        }

        const filteredConnections = currentNode.ConnectionsData?.filter(connection =>
            (connection?.ConnectionName === 'Standard' && currentNode?.IsPlatformSwitch)
            || !currentNode?.IsPlatformSwitch
        ) || [];

        const defaultConnection = filteredConnections.find(connection => connection.IsDefault === true);

        if (defaultConnection) {
            const defaultIndex = filteredConnections.indexOf(defaultConnection);
            const isPreview = props.isPreview;
            const selectionMethod = isPreview ? procedureStore.addUserPreviewedSelection : procedureStore.addUserSelection;
            selectionMethod(
                defaultConnection.ConnectedTo,
                defaultIndex,
                getProcedureText(defaultConnection, "ConnectionName", currentProcedure) || `[${generalStore.translate('unlabeled')}]`
            );
        }
    }, [currentNode.NodeId, isSelectionStep, sessionViewerOpen]); // Dependencies to trigger effect

    function select(event, index, connectionName) {
        if (procedureStore.sessionViewerOpen) {
            return;
        }

        const connection = !!event.target.value ? event.target.value : `procedure-end_${event.target.name}`
        const isPreview = props.isPreview;
        const selectionMethod = isPreview ? procedureStore.addUserPreviewedSelection : procedureStore.addUserSelection;
        selectionMethod(connection, index, connectionName);
    }

    function getClassName(connection, i, currentNode) {
        let className = 'connection-selection';
        if (sessionViewerOpen) {
            className += ' session-viewer'
        }

        if (connection.IsDefault && currentNode.userSelectionIndex === undefined) {
            className += ' selected';
        }

        if (currentNode.userSelectionIndex === i) {
            className += ' selected';
        } else if (currentNode.userSelection === `procedure-end_${i}`) {
            className += ' selected';
        }

        return className;
    }

    if (!isSelectionStep) {
        return null;
    }

    const filteredConnections = currentNode.ConnectionsData.filter(connection =>
        (connection?.ConnectionName === 'Standard' && currentNode?.IsPlatformSwitch)
        || !currentNode?.IsPlatformSwitch
    );

    return (
        <div className="selection-menu-container">
            <div className="selection-menu">
                {filteredConnections.map((connection, i) =>
                    <button
                        key={i}
                        className={getClassName(connection, i, currentNode)}
                        name={i.toString()}
                        value={connection.ConnectedTo}
                        onClick={e => select(e, i, getProcedureText(connection, "ConnectionName", currentProcedure) || `[${generalStore.translate('unlabeled')}]`)}
                    >
                        {getProcedureText(connection, "ConnectionName", currentProcedure) || `[${generalStore.translate('unlabeled')}]`}
                    </button>
                )}
            </div>
        </div>
    )
});

SelectionMenu.propTypes = {
    isPreview: PropTypes.bool.isRequired
}

export default SelectionMenu